var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"delete-dashboard-modal"},[_c('p',[_vm._v(_vm._s(_vm.$t('deleteWidgetsPopup.subTitle'))+"?")])])
}
var staticRenderFns = []

export { render, staticRenderFns }